Vue.component("cfour-random-items", {

    delimiters: ["${", "}"],

    props: {
        template: {
            default: "#vue-cfour-productwall-items",
            type: String
        },
        cols: {
            default: 3
        },
        rows: {
            default: 4
        }
    },

    data()
{
        return {
            items: [],
            gridClass: 12
        };
    },

    created()
{
        this.$options.template = this.template;
        $.ajax({
            url: "/rest/CfourProductWall/allitems",
            method: "post",
            data: "cols=" + this.cols + "&rows=" + this.rows
        }).done(data =>
{
            this.gridClass = 12 / this.cols;
            if (typeof data === "string")
{
                this.items = JSON.parse(data);
                console.log(this.items);
            }
            else
{
                this.items = data;
            }
            $(window).trigger("resize");
        });
    }
});
